import * as React from 'react';
import { IconProps } from '../types';

const IcCashierMerge = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      fill={props?.fill ?? '#232F3E'}
      d="m22.855 10.557-5.943-5.945a2.04 2.04 0 0 0-2.913 0l-1.515 1.516-1.515-1.516c-.7-.7-2.098-.7-2.914 0l-5.943 5.945a2.041 2.041 0 0 0 0 2.915l5.943 5.945c.35.35.933.583 1.515.583.583 0 1.049-.233 1.515-.583l1.515-1.515 1.515 1.515c.466.35.932.583 1.515.583.583 0 1.049-.233 1.515-.583l5.944-5.945c.582-.7.582-2.099-.234-2.915ZM9.92 18.485c-.233.233-.7.233-.932 0L3.16 12.539c-.233-.233-.233-.7 0-.932L9.104 5.66c.117-.116.233-.233.466-.233.117 0 .35.117.466.233l1.515 1.516-3.38 3.38a2.041 2.041 0 0 0 0 2.915l3.38 3.38-1.631 1.633Zm2.564-10.26 3.38 3.382c.232.233.232.699 0 .932l-3.38 3.38-3.38-3.38c-.233-.233-.233-.7 0-.932l3.38-3.381Zm9.323 4.314-5.944 5.946c-.233.233-.699.233-.932 0l-1.515-1.516 3.38-3.38a2.041 2.041 0 0 0 0-2.915l-3.38-3.38 1.515-1.516c.116-.117.233-.233.466-.233.117 0 .35.116.466.233l5.944 5.945c.233.117.233.583 0 .816Z"
    />
  </svg>
);

export default IcCashierMerge;
